import { NgModule } from '@angular/core';
import { AuthComponent } from './components/auth.component';
import { AuthGuard } from './guards/auth.guard';
import { AuthService } from './services/auth.service';
import { RouterModule } from '@angular/router';
import { RedirectGuard } from './guards/redirect.guard';
import { ChangePasswordGuard } from './guards/change-password.gaurd';

@NgModule({
	imports: [RouterModule],
	declarations: [AuthComponent],
	providers: [AuthService, AuthGuard, RedirectGuard, ChangePasswordGuard],
	exports: [AuthComponent]
})
export class AuthModule {}
